import type { CampaignPatchApiData } from '@navio/nsdk';
import type { ApiInput } from '../../utils';

const appendImage = (formData: FormData, image: File | Blob | null | undefined) => {
  if (image instanceof Blob) {
    formData.append('image', image);
    return;
  }
  if (image === null) {
    formData.append('image', '');
  }
};

export const campaignPatchFormData = ({
  campaignId: _,
  serviceOrganizationId,
  name,
  description,
  isForNewUserOnly,
  expiresAt,
  expiryDaysAfterReceiving,
  authCode,
  discounts,
  image
}: ApiInput<CampaignPatchApiData> & { authCode?: string; image?: File | Blob | null }): FormData => {
  const formData = new FormData();
  if (serviceOrganizationId != null) {
    formData.append('service_organization_id', String(serviceOrganizationId));
  }
  if (name != null) {
    formData.append('name', name);
  }
  if (description != null) {
    formData.append('description', description);
  }
  if (isForNewUserOnly != null) {
    formData.append('is_for_new_user_only', String(isForNewUserOnly));
  }
  if (expiresAt !== undefined) {
    formData.append('expires_at', expiresAt ?? '');
  }
  if (expiryDaysAfterReceiving !== undefined) {
    formData.append(
      'expiry_days_after_receiving',
      expiryDaysAfterReceiving != null ? String(expiryDaysAfterReceiving) : ''
    );
  }
  if (authCode != null) {
    formData.append('auth_code', authCode);
  }
  if (discounts != null) {
    formData.append('discounts', JSON.stringify(discounts));
  }
  appendImage(formData, image);
  return formData;
};
